/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {AppSettings} from '../../../../../models/Constants';
import {DppSearchCriteria} from '../../../../../models/dpp/search-criteria';

@Component({
  selector: 'app-passport-search',
  templateUrl: './passport-search.component.html',
  styleUrl: './passport-search.component.scss',
  standalone: false,
})
export class PassportSearchComponent implements OnDestroy {
  readonly translate: TranslateService = inject(TranslateService);

  @Input() numberOfFoundPassports = 0;
  @Output() searchChange = new EventEmitter<DppSearchCriteria>();

  criteria: DppSearchCriteria = {};

  readonly destroy$ = new Subject<void>();
  readonly searchChange$ = new Subject<DppSearchCriteria>();

  constructor() {
    this.searchChange$
      .pipe(
        debounceTime(AppSettings.SEARCH_BAR_INPUT_TO_REQUEST_WAIT_TIME_IN_MS),
        takeUntil(this.destroy$),
      )
      .subscribe((criteria) => {
        this.searchChange.emit(criteria);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCriteriaChange() {
    this.searchChange$.next(this.criteria);
  }

  onClearSearch(field: keyof DppSearchCriteria) {
    delete this.criteria[field];
    this.onCriteriaChange();
  }
}
